import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { Typography } from '../../components/generic.tsx'
import { WithoutNavigation } from '../../components/Layouts.tsx'
import { deviceListQuery, waitForDeviceRecord } from '../../data/devices.ts'
import { CsvExportForm } from '../../features/measurements/CsvExportForm.tsx'
import { useNavigateBack } from '../../navigation.ts'

export const Route = createFileRoute('/_app/reports/csv')({
	validateSearch: z.object({ deviceId: z.string().optional() }),
	component: RouteComponent,
	loader: async ({ context: { queryClient, impersonation } }) => {
		await Promise.all([
			queryClient.ensureQueryData(deviceListQuery(impersonation?.partyAccountId)),
			waitForDeviceRecord(queryClient, impersonation?.partyAccountId, { timeoutMs: 3000 }),
		])
	},
})

function RouteComponent() {
	const { t } = useTranslation()
	const navigateBack = useNavigateBack()
	const { deviceId } = Route.useSearch({ select: ({ deviceId }) => ({ deviceId }) })
	return (
		<WithoutNavigation
			onBack={() => navigateBack({ fallback: '/measurements' })}
			topBar={<Typography variant='h1'>{t(($) => $.csv.downloadCSV)}</Typography>}
		>
			<CsvExportForm initialSelectedDeviceId={deviceId} />
		</WithoutNavigation>
	)
}
